import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const jwt = localStorage.getItem("auth_token");
  const kiosk = localStorage.getItem("kiosk_token");

  if (kiosk) {
    config.headers["Authorization"] = `Bearer ${kiosk}`;
  } else if (jwt) {
    config.headers["Authorization"] = `Bearer ${jwt}`;
  }
  return config;
});
